/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionCancelInfoDTO
 */
export interface SubscriptionCancelInfoDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof SubscriptionCancelInfoDTO
     */
    reasons: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionCancelInfoDTO
     */
    improvement?: string;
}

/**
 * Check if a given object implements the SubscriptionCancelInfoDTO interface.
 */
export function instanceOfSubscriptionCancelInfoDTO(value: object): value is SubscriptionCancelInfoDTO {
    if (!('reasons' in value) || value['reasons'] === undefined) return false;
    return true;
}

export function SubscriptionCancelInfoDTOFromJSON(json: any): SubscriptionCancelInfoDTO {
    return SubscriptionCancelInfoDTOFromJSONTyped(json, false);
}

export function SubscriptionCancelInfoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionCancelInfoDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'reasons': json['reasons'],
        'improvement': json['improvement'] == null ? undefined : json['improvement'],
    };
}

export function SubscriptionCancelInfoDTOToJSON(value?: SubscriptionCancelInfoDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'reasons': value['reasons'],
        'improvement': value['improvement'],
    };
}

